import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BROCHURE_URL = `${API}/brochure`;

export const fileUrl = (urlPath) => {
  if (!urlPath) return "";
  if (urlPath.startsWith("http")) return urlPath;
  return `${BACKEND_URL}${urlPath}`;
};

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const setAdminToken = (token) => {
  if (token) {
    localStorage.setItem("vps_admin_token", token);
  } else {
    localStorage.removeItem("vps_admin_token");
  }
};

export const getAdminToken = () => localStorage.getItem("vps_admin_token");

export const adminApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminUpload = async (path, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const token = getAdminToken();
  const res = await axios.post(`${API}${path}`, fd, {
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
    },
  });
  return res.data;
};
